import initialState from './initialState';
import {
    FETCH_LETTERS, RECEIVE_LETTERS
} from '../actions/actionTypes';

export default function lettersReducer(state = initialState.letters, action) {
    let newState = {};
    switch (action.type) {
        case FETCH_LETTERS:
            return { ...state, fetching: true };
        case RECEIVE_LETTERS:
            newState.items = action.letters.items;
            newState.pagination = action.letters.pagination;
            newState.fetching = false;
            return newState;
        default:
            return state;
    }
}